import { render, staticRenderFns } from "./EdgeSelectList.vue?vue&type=template&id=0b112952&"
import script from "./EdgeSelectList.vue?vue&type=script&lang=js&"
export * from "./EdgeSelectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports